import React from 'react';
import { NavLink } from 'react-router-dom';

const navigationItem = ( props ) => {
    const onClickNavLink = (e) => {
        props.toggleAction();
        props.clicked(props.link);
    }

    return (
    <li className="nav-link">
        <span className={`icon ${props.link}`}></span>
        <NavLink 
            to={`${props.isUserSignedIn?'':'/discover'}/thematic/${props.link}`}
            exact={props.exact}
            onClick={onClickNavLink}
            activeClassName="active">
                {props.children}
        </NavLink>

    </li>);
};

export default navigationItem;


// WEBPACK FOOTER //
// ./src/containers/Navigation/NavigationsItems/NavigationItem/NavigationItem.js